export default {
  ['title']: '大赛动态',
  ['sub-title']: 'COMPETITION NEWS',
  ['action-notice']: '大赛通知',
  ['action-advices']: '大赛动态',
  ['action-history']: '历届作品',
  ['events-history']: '往届赛事新闻'
}
